import { css } from '@emotion/css';
import { Flex } from 'antd';
import type React from 'react';
import type { LabResultResponse } from '../../../generated/openapi/befunde-api';
import { useLabResultViewStore } from '../../../store/useLabResultViewStore.ts';
import { LabResultCumulativeRenderer } from './cumulative/LabResultCumulativeRenderer.tsx';
import { CumulativeLabResultTabAndFilter } from './filter/CumulativeLabResultTabAndFilter.tsx';
import { LabResultTabAndFilter } from './filter/LabResultTabAndFilter.tsx';
import { LabResultAttachmentRenderer } from './single/attachments/LabResultAttachmentRenderer.tsx';
import { LabResultSingleRenderer } from './single/LabResultSingleRenderer.tsx';
import { useGridClassNames } from './single/orderresult/OrderResult.styles.ts';

const useOrderResultRendererClassNames = () => {
  return {
    wrapper: css`
      overflow-y: auto;
      flex-grow: 1;
    `,
  };
};

export const BefundDetailsLayout: React.FC<{
  selectedResult: LabResultResponse;
  deemphasizePathological: boolean;
}> = ({ selectedResult, deemphasizePathological }) => {
  const { detailsClassName } = useGridClassNames();
  const { wrapper } = useOrderResultRendererClassNames();
  const tabState = useLabResultViewStore(state => state.tabState);
  const cumulative = useLabResultViewStore(state => state.cumulative);

  return (
    <Flex vertical className={detailsClassName}>
      {cumulative ? (
        <>
          <CumulativeLabResultTabAndFilter />
          <Flex className={wrapper} vertical>
            <LabResultCumulativeRenderer result={selectedResult} deemphasizePathological={deemphasizePathological} />
          </Flex>
        </>
      ) : (
        <>
          <LabResultTabAndFilter
            hasSpecimen={!!selectedResult.observationSpecimen}
            values={selectedResult.observationResults.length}
            pathological={selectedResult.countPathological}
            attachments={selectedResult.labResultAttachments}
          />
          <Flex className={wrapper} vertical>
            {tabState.type === 'VALUE' ? (
              <LabResultSingleRenderer result={selectedResult} deemphasizePathological={deemphasizePathological} />
            ) : (
              <LabResultAttachmentRenderer
                key={selectedResult.labResultAttachments[tabState.tab as number].id}
                attachment={selectedResult.labResultAttachments[tabState.tab as number]}
              />
            )}
          </Flex>
        </>
      )}
    </Flex>
  );
};
